import React from 'react';
import { Card } from 'react-bootstrap';

const GroupAssetList = ({ assets, onAssetCardClick }) => {
    if (!assets) {
        return <div className="tyk-panel">Loading assets...</div>;
    }

    return (
        <div>
            <div className="tyk-toolbar">
                <div>
                    <span className="tyk-kicker">Inventory</span>
                    <h3 className="m-0 text-white">Asset List</h3>
                </div>
                <span className="tyk-pill">{assets.length} assets</span>
            </div>
            <div className="tyk-grid">
                {assets.map((asset) => (
                    <Card
                        as="button"
                        type="button"
                        className="card tyk-card border-0 p-0 text-start text-white"
                        onClick={() => onAssetCardClick(asset)}
                        key={asset.id}
                    >
                        <Card.Body className="d-flex h-100 flex-column gap-3 p-3">
                            {asset.imageURL && (
                                <img src={asset.imageURL} alt={asset.assetName || 'Group asset'} className="h-48 w-full rounded-xl object-cover" />
                            )}
                            <div>
                                <Card.Title className="mb-2 text-xl font-bold">{asset.assetName || 'Untitled asset'}</Card.Title>
                                <Card.Text className="tyk-clamp-4 text-slate-300">{asset.assetDescription || 'No description has been added yet.'}</Card.Text>
                            </div>
                        </Card.Body>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default GroupAssetList;
